import { Tag, Typography, Flex, Tooltip } from 'antd';
import { XIcon } from '@phosphor-icons/react';
import styled from '@emotion/styled';

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

interface IRejectedTagsProps {
  tags: Array<string>;
  closable: boolean;
  onCloseTag?: (tag: string) => void;
  closeTooltip?: string;
}

const RejectedTags = ({ tags, closable, onCloseTag, closeTooltip }: IRejectedTagsProps) => (
  <div>
    <Typography.Text style={{ fontWeight: 400, fontSize: 12 }}>Rejected Tags</Typography.Text>
    <Flex vertical gap={4}>
      <TagsWrapper>
        {tags.map(tag => (
          <Tag
            key={tag}
            color="red"
            closable={closable}
            closeIcon={
              closeTooltip ? (
                <Tooltip title={closeTooltip}>
                  <XIcon
                    style={{
                      color: '#cf1322',
                    }}
                  />
                </Tooltip>
              ) : (
                <XIcon
                  style={{
                    color: '#cf1322',
                  }}
                />
              )
            }
            onClose={() => onCloseTag?.(tag)}
            style={{
              borderRadius: 20,
              textTransform: 'uppercase',
            }}
          >
            {tag}
          </Tag>
        ))}
      </TagsWrapper>
    </Flex>
  </div>
);

export default RejectedTags;
